import { useState } from "react";
import {
  FaCamera,
  FaExclamationTriangle,
  FaInstagram,
  FaSnapchatGhost,
  FaTimes,
  FaWhatsapp,
} from "react-icons/fa";
import Drawer from "../../mainComponents/Drawer";
import { AgeButton } from "../../mainComponents/ageButton";
import OptionsDrawerContent from "./component/optionsDrawer";
import { useNavigate, useParams } from "react-router-dom";
import { useGetMessageIdQuery } from "../../redux/messageView";

export default function NglMessageView() {
  const [bgColor, setBgColor] = useState("#ff5298");
  const [bgImage, setBgImage] = useState<string | null>(null);
  const [isOptionsDrawerOpen, setIsOptionsDrawerOpen] = useState(false);
  const { id } = useParams<{ id: string }>();
  const { data, error, isLoading } = useGetMessageIdQuery(id ?? "");
  console.log("data coming from api", data);
  

  const handleColorClick = () => {
    const randomColor = getRandomColor();
    const gradient = `linear-gradient(135deg, ${randomColor}, ${shadeColor(
      randomColor,
      -20
    )})`;
    setBgColor(gradient);
    setBgImage(null);
  };

  function getRandomColor() {
    const letters = "0123456789ABCDEF";
    let color = "#";
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  function shadeColor(color: string, percent: number) {
    const num = parseInt(color.slice(1), 16);
    const amt = Math.round(2.55 * percent);
    const R = (num >> 16) + amt;
    const G = ((num >> 8) & 0x00ff) + amt;
    const B = (num & 0x0000ff) + amt;
    return `rgb(${Math.min(255, Math.max(0, R))}, ${Math.min(
      255,
      Math.max(0, G)
    )}, ${Math.min(255, Math.max(0, B))})`;
  }

  const handleImageUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setBgImage(reader.result as string);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleDelete = () => {
    setIsOptionsDrawerOpen(false);
  };

  const handleBlock = () => {
    setIsOptionsDrawerOpen(false);
  };

  const handleReport = () => {
    setIsOptionsDrawerOpen(false);
  };

  const navigate = useNavigate();

  return (
    <div className="h-screen pt-6 bg-white flex flex-col items-center justify-between py-6 px-4">
      <div className="flex justify-between items-center w-full px-4">
        <FaExclamationTriangle
          className="text-lg text-gray-400/80 size-6"
          onClick={() => setIsOptionsDrawerOpen(true)}
        />
        <div className="flex gap-1 bg-gray-300 rounded-full">
          <div className="bg-gray-400 px-3 p-2 rounded-3xl">
            <FaWhatsapp
              className="text-white text-lg size-4"
              style={{ cursor: "pointer" }}
            />
          </div>
          <div className="px-3 p-2">
            <FaInstagram
              className="text-white text-lg size-4"
              style={{ cursor: "pointer" }}
            />
          </div>
          <div className="px-3 p-2">
            <FaSnapchatGhost
              className="text-white text-lg size-4"
              style={{ cursor: "pointer" }}
            />
          </div>
        </div>
        <FaTimes
          onClick={() => navigate(-1)}
          className="text-lg text-gray-400/80 size-6"
          style={{ cursor: "pointer", fontWeight: "700" }}
        />
      </div>

      <div
        className="mt-20 w-md max-w-sm rounded-3xl shadow-md overflow-hidden"
        style={{
          background: bgImage ? `url(${bgImage})` : bgColor,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="text-white text-center py-5 md:py-6 font-extrabold text-2xl px-10">
          send me anonymous
          <br /> messages!
        </div>

        <div className="text-center bg-white text-black px-6 py-6 md:py-10 text-2xl font-extrabold">
          {isLoading
            ? "Loading..."
            : error
            ? "Error loading message."
            : data?.data?.content ?? "No message found"}
        </div>
      </div>

      <div className="flex items-center gap-6 mt-6">
        <div
          className="w-7 h-7 rounded-full bg-gradient-to-r from-pink-500 via-yellow-400 to-blue-500 cursor-pointer"
          onClick={handleColorClick}
          title="Random Background Color"
        />

        <label htmlFor="upload-photo">
          <div className="p-1 bg-white/80 rounded-full flex items-center justify-center cursor-pointer">
            <FaCamera className="text-gray-400 text-xl rounded-md w-7 h-7" />
          </div>
        </label>
        <input
          id="upload-photo"
          type="file"
          accept="image/*"
          onChange={handleImageUpload}
          className="hidden"
        />
      </div>

      <div className="w-full max-w-sm mt-auto pb-16">
        <div className="text-base font-medium text-gray-600 text-center mb-4">
          Sent with <span className="text-red-500">❤️</span> from team broChat
        </div>

        <AgeButton className="bg-black rounded-full px-6 py-3 w-full flex items-center justify-center gap-2 text-lg font-semibold">
          <FaWhatsapp className="text-white text-lg font-bold w-10 size-7" />
          reply
        </AgeButton>
      </div>

      <Drawer
        isOpen={isOptionsDrawerOpen}
        position="bottom"
        onClose={() => setIsOptionsDrawerOpen(false)}
      >
        <OptionsDrawerContent
          handleDelete={handleDelete}
          handleBlock={handleBlock}
          handleReport={handleReport}
        />
      </Drawer>
    </div>
  );
}
